<div [title]="'pluginStore' | i18n" class="tw-flex tw-flex-col tw-gap-3 tw-w-full">
  <!-- Cards fill each row (repeat count is derived, not "auto-fit"): as long as 4 columns each
       fit at their 124px floor, the track size is forced to exactly 100%/4 so the browser can
       never place a 5th; once the container is too narrow for that, the 124px floor takes over
       and the column count drops (and wraps) the normal auto-fit way. -->
  <div
    class="tw-grid tw-grid-cols-[repeat(auto-fit,minmax(max(124px,(100%-3*0.75rem)/4),1fr))] tw-gap-3 tw-w-full tw-items-stretch"
  >
    @for (coupon of visibleCoupons(); track coupon.id) {
      <app-coupon-card
        [coupon]="coupon"
        (redeem)="onCouponRedeem({ couponId: $event })"
      ></app-coupon-card>
    }
  </div>
</div>
